// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clock-ampm[data-v-76968bd4] {\n  font-size: 13px;\n}\nh4[data-v-76968bd4], span[data-v-76968bd4] {\n  line-height: 0.5rem !important;\n}\ndiv[data-v-76968bd4] {\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
